export default "__VITE_ASSET__7ef127a0__"